import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useSelector, connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SurveyRenderer, {
  SUBMITTED_MESSAGE,
  VisuallyHidden
} from '../../PopupSurveyModal/SurveyRenderer/SurveyRenderer';
import { usePopupFeedback } from '../../../hooks/usePopupFeedback';
import {
  useSurveyResponseStatus,
  useInvalidateSurveyStatus,
  isSurveyCompleted
} from '../../../hooks/useSurveyResponseStatus';
import { Creators as VideoActions } from '../../../store/ducks/newCourse/actions';

const SUBMIT_ERROR_MESSAGE = 'Não foi possível enviar sua resposta.';
const RETRY_LABEL = 'Tentar novamente';
const LOADING_MESSAGE = 'Carregando pesquisa...';

export const SurveySubmitError = ({ onRetry }) => (
  <div role="alert" style={{ textAlign: 'center', color: '#b91c1c', paddingTop: 8 }}>
    {SUBMIT_ERROR_MESSAGE}{' '}
    <button type="button" className="btn btn-link" onClick={onRetry}>
      {RETRY_LABEL}
    </button>
  </div>
);

SurveySubmitError.propTypes = { onRetry: PropTypes.func.isRequired };

export const useSurveySubmission = formCode => {
  const { submit } = usePopupFeedback();
  const invalidateStatus = useInvalidateSurveyStatus();
  const [lastAnswers, setLastAnswers] = useState(null);
  const send = answers => {
    setLastAnswers(answers);
    submit.mutate({ formCode, answers }, { onSuccess: () => invalidateStatus(formCode) });
  };
  return {
    send,
    retry: () => send(lastAnswers),
    hasFailed: submit.isError,
    hasSucceeded: submit.isSuccess
  };
};

export const Survey = ({ navigationContent, setCourseSelected }) => {
  const surveyData = useSelector(state => state.newCourse.selected.rawSurvey);
  const formCode = _.get(surveyData, 'cr_code');
  const statusQuery = useSurveyResponseStatus(formCode);
  const submission = useSurveySubmission(formCode);
  if (!surveyData) return null;
  if (statusQuery.isLoading) {
    return <p role="status" aria-live="polite">{LOADING_MESSAGE}</p>;
  }
  const next = _.get(navigationContent, 'next');
  return (
    <div style={{ paddingBottom: '10px' }}>
      <SurveyRenderer
        key={formCode}
        survey={surveyData}
        onSubmit={submission.send}
        forceThankYou={isSurveyCompleted(statusQuery.data)}
        nextNavigationContent={next ? () => setCourseSelected(next) : undefined}
        isCourseContent
      />
      <VisuallyHidden role="status" aria-live="polite">
        {submission.hasSucceeded ? SUBMITTED_MESSAGE : ''}
      </VisuallyHidden>
      {submission.hasFailed && <SurveySubmitError onRetry={submission.retry} />}
    </div>
  );
};

Survey.propTypes = {
  navigationContent: PropTypes.shape({ next: PropTypes.shape({}) }),
  setCourseSelected: PropTypes.func.isRequired
};

Survey.defaultProps = { navigationContent: { prev: null, next: null } };

const mapStateToProps = (state) => ({
  navigationContent: state.newCourse.navigationContent,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(VideoActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Survey);
